import { Box, LinearProgress, Typography } from '@mui/material'
import React from 'react'

export const PageLoader = () => {
    return (
        <div
            style={{
                textAlign: 'center',
                opacity: '0.4',
                backgroundColor: 'white',
            }}
        >
            <div style={{ textAlign: 'center' }}>
                {/* <img src={load} style={{ marginTop: '15%', marginBottom: '0px' }} /> */}
                <Typography
                    sx={{
                        color: '#444444',
                        fontSize: '36px',
                        fontStyle: 'normal',
                        fontWeight: '400',
                        lineHeight: 'normal',
                        margin: 0,
                    }}
                >
                    Loading...
                </Typography>
            </div>
        </div>
    )
}

export const LineLoader = (props) => {
    return (
        <>
            <Box sx={{ width: '100%' }} display={props.loader ? 'block' : 'none'}>
                <LinearProgress color="success" />
            </Box>
        </>
    )
}